import {
  createIamClient,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

export enum AccessRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  CANCELLED = 'CANCELLED'
}

export interface AccessRequest {
  id: string;
  status: AccessRequestStatus;
  requesterUserId: string;
  requesterName?: string;
  requesterEmail: string;
  targetOrganisationId?: string;
  targetTenantId?: string;
  requestedAt: string;
  resolvedAt?: string;
  resolvedByUserId?: string;
}

export interface CreateAccessRequest {
  targetOrganisationId?: string;
  targetTenantId?: string;
}

export const accessRequestPermissions = {
  SEARCH: 'iam.search-access-requests',
  GET: 'iam.get-access-request',
  DENY: 'iam.deny-access-request'
};

const client = createIamClient('/rest/access-requests');
const userScopedClient = createIamClient('/rest/users');

export const searchAccessRequests: SearchOperation<AccessRequest> = searchRequestFactory<AccessRequest>(client, {
  permissionId: accessRequestPermissions.SEARCH
});

export const listMyAccessRequests: FindOperation<AccessRequest[], string> = getRequestFactory<AccessRequest[], string>(
  userScopedClient,
  { pattern: '/{userId}/access-requests' }
);

export const getAccessRequest: FindOperation<AccessRequest, string> = getRequestFactory<AccessRequest, string>(client, {
  permissionId: accessRequestPermissions.GET
});

export const createAccessRequest: SaveOperation<CreateAccessRequest, AccessRequest> = postRequestFactory<
  CreateAccessRequest,
  AccessRequest
>(client, { pattern: '' });

export const denyAccessRequest: SaveOperation<void, AccessRequest> = postRequestFactory<void, AccessRequest>(client, {
  pattern: '/{id}/deny',
  permissionId: accessRequestPermissions.DENY
});

export const cancelAccessRequest: SaveOperation<void, AccessRequest> = postRequestFactory<void, AccessRequest>(client, {
  pattern: '/{id}/cancel'
});
